import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export const Footer = () => {
  const [ct, setCt] = useState({
    contact_email: "contato@leveessenza.com.br",
    hours: "Seg-Sex, 9h30 às 19h",
    city: "Londrina - PR/ Brasil",
    whatsapp_display: "(43) 99692-5123",
  });
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/content`)
      .then((r) => r.json())
      .then((c) => setCt((prev) => ({ ...prev, ...c })))
      .catch(() => {});
  }, []);
  return (
  <footer data-testid="main-footer" className="bg-military-dark text-offwhite pt-24 md:pt-32 overflow-hidden">
    <div className="w-full max-w-[1600px] mx-auto px-6 md:px-12 lg:px-24">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-24">
        <div className="md:col-span-5">
          <p className="font-serif italic text-3xl mb-6">leve <span className="not-italic font-semibold text-baby">essenza</span></p>
          <p className="text-offwhite/60 text-sm leading-relaxed max-w-sm">
            Suplementação com curadoria editorial para quem leva o treino a sério — e a vida com leveza.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-[0.25em] text-baby font-semibold mb-6">Navegação</p>
          <ul className="space-y-3 text-sm text-offwhite/70">
            {[["Início", "/"], ["Todos os produtos", "/produtos"], ["Marcas", "/marcas"], ["Ofertas", "/produtos?ofertas=1"]].map(([l, to]) => (
              <li key={l}>
                <Link
                  to={to}
                  data-testid={`footer-link-${l.toLowerCase().replace(/\s/g, "-")}`}
                  className="hover:text-baby transition-colors duration-300"
                >
                  {l}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="text-xs uppercase tracking-[0.25em] text-baby font-semibold mb-6">Contato</p>
          <ul className="space-y-3 text-sm text-offwhite/70">
            <li>{ct.contact_email}</li>
            <li>
              <a
                data-testid="footer-whatsapp-link"
                href={`https://wa.me/${process.env.REACT_APP_WHATSAPP_NUMBER}`}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-baby transition-colors duration-300"
              >
                WhatsApp: {ct.whatsapp_display}
              </a>
            </li>
            <li>{ct.hours}</li>
            <li>{ct.city}</li>
          </ul>
        </div>
      </div>
    </div>
    <div className="border-t border-offwhite/10">
      <motion.p
        initial={{ y: "40%", opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1.2, ease: [0.76, 0, 0.24, 1] }}
        className="font-serif font-semibold text-[13vw] leading-none text-center text-offwhite/10 select-none tracking-tight py-6"
        data-testid="footer-giant-logo"
      >
        leve essenza
      </motion.p>
      <p className="text-center text-xs text-offwhite/40 pb-8">© 2026 leve essenza. Todos os direitos reservados.</p>
    </div>
  </footer>
  );
};
